var hyphenChar = " - ";
export var getLeagueNameWithoutCountry = function (league, regionName) {
    if (!league.name) {
        return "";
    }
    var leagueName = league.name.replace(regionName, "").replace(/  /g, " ");
    if (leagueName.startsWith(hyphenChar) || leagueName.endsWith(hyphenChar)) {
        leagueName = leagueName.replace(hyphenChar, "");
    }
    return leagueName.replace(/^ /, "");
};
//# sourceMappingURL=getLeagueNameWithoutCountry.js.map